<template>
  <div :style="containerStyle"> 
    <div style="display:flex;background-color:#c9c9c9;gap:3px;padding:4px">
      <ks-button style="color: #3f3f3f;text-decoration:none" color="link" @onClick="crop(outputType)"> <i class="fa fa-cut" aria-hidden="true"></i> </ks-button>
      <ks-button style="color: #3f3f3f;text-decoration:none" color="link" @onClick="reset" :disabled="bckSrc == newSrc"><i class="fa fa-undo" aria-hidden="true"></i></ks-button>
    </div>
    <vue-cropper
      :ref="`image-cropper-${_uid}`"
      style="width:100%;height:100%"
      :src="src"
      :alt="src"
      :aspectRatio="aspectRatio"
      :autoCropArea="1"
    />
  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
  name: "image-cropper",
  components: {VueCropper},
  props: {
    /**
      attribute
      name: src 
      description: url src
    **/
    src: {
      type: String,
      required: true
    },
    /**
      attribute
      name: fileName 
      description: file name
    **/
    fileName:{
      type: String,
      default: null,
    },
    /**
      attribute
      name: height 
      description: height
    **/
    height: {
      type: String,
      default: '40vh'
    },
    /**
      attribute
      name: width 
      description: width
    **/
    width:{
      type: String,
      default: '100%'
    },
    /**
      attribute
      name: classes 
      description: classes
    **/
    classes: {
      type: String,
      default: ''
    },
    /**
      attribute
      name: aspectRatio 
      description: aspectRatio
    **/
    aspectRatio: {
      type: Number,
      default: 1 //16/9, 9/16
    },
    /**
      attribute
      name: outputType 
      description: output File Type
    **/
    outputType:{
      type:String,
      default: null
    },
  },
  computed:{
    containerStyle(){
      return this.classes && this.classes.length > 0?{}:{'height': this.height, 'width': this.width, 'display': "flex", 'flex-direction': "column", "margin": "10px"};
    },
    cropper(){
      return this.$refs[`image-cropper-${this._uid}`];
    }
  },
  watch: {
    src: function (val) {
      this.bckSrc = val;
      this.replace(val);
    }
  },
  methods: {
    crop(type = null) {
      this.cropper.getCroppedCanvas().toBlob((blob) => {
        let urlFile = window.URL.createObjectURL(blob);
        this.replace( urlFile );
        switch (type) {
          case 'blob':
            this.$emit("crop", blob);
            return blob;
            break;
          case 'url':
            this.$emit("crop", urlFile);
            return urlFile;
          default:
            let fileName = this.fileName;
            if(!fileName){
              const ext = blob.type.split('/').pop();
              fileName =  `cropped-image-${this._uid}.${ext}`;
            }
            const file =  new File([blob], fileName, {type: blob.type});
            this.$emit("crop", file);
            return file;
            break;
        }
      });
    },
    async getFile(){
      const response = await fetch(this.newSrc);
      const blob = await response.blob();
      let fileName = this.fileName;
      if(!fileName){
        const ext = blob.type.split('/').pop();
        fileName =  `cropped-image-${this._uid}.${ext}`;
      }
      return new File([blob], fileName,{type: blob.type});
    },
    async reset() {
      // clear
      this.cropper.replace(this.bckSrc);
      const response = await fetch(this.bckSrc);
      const blob = await response.blob();
      let fileName = this.fileName;
      if(!fileName){
        const ext = blob.type.split('/').pop();
        fileName =  `cropped-image-${this._uid}.${ext}`;
      }
      this.$emit("reset", new File([blob], fileName,{type: blob.type}));
    },
    destroy() {
      this.cropper.destroy();
    },
    replace(src = null, hasSameSize = false) {
      this.newSrc = src;
      this.cropper.replace(src, hasSameSize);
    }
  },
  data(){
    return {
      bckSrc : this.src,
      newSrc : this.src
    }
  }
}
</script>